import { useTranslation } from 'react-i18next';
import { useUpdateInvestmentService } from '../service';
import { Investment } from '../../generated/graphql';
import { useInvestmentForm } from './useInvestmentForm';
import { updateInvestmentServiceInputFromForm } from '../util';

export type UseEditInvestmentModalFormParams = {
  investment: Investment;
  afterUpdate?: (investment: Investment) => Promise<void>;
};

export function useEditInvestmentModalForm({ investment, afterUpdate }: UseEditInvestmentModalFormParams) {
  const { t: tForm } = useTranslation('form');
  const { t: tInvestment } = useTranslation('investment');
  const { updateInvestmentService } = useUpdateInvestmentService();
  const useInvestmentFormReturn = useInvestmentForm({
    investmentID: investment.id,
    householdID: investment.householdID,
    saveOnChange: false,
    handleSubmit: async (data) => {
      updateInvestmentService.mutate(updateInvestmentServiceInputFromForm(data, investment), {
        onSuccess: async () => await afterUpdate?.(investment),
      });
    },
  });
  const isLoading = updateInvestmentService.isLoading || useInvestmentFormReturn.isLoadingFormData;
  return { tCashAccount: tInvestment, tForm, useInvestmentFormReturn, isLoading };
}
